import React, { useState } from "react";
import { SearchResult } from "../Types/SearchResult.interface";
import "../Styles/advancedSearch.css";
import QuickSearchResult from "../Components/QuickSearchResult";

export default function AdvanceSearchPage() {
  const [searchTitle, setSearchTitle] = useState("");
  const [searchAuthor, setSearchAuthor] = useState("");
  const [searchResult, setSearchResult] = useState<SearchResult | null>(null);
  const [isSearching, setIsSearching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [sortBy, setSortBy] = useState("");

  const handleCategoryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedCategory(event.target.value);
  };

  const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedLanguage(event.target.value);
  };

  const handleSearch = async () => {
    setIsLoading(true);
    setSearchResult(null);
    setIsSearching(true);
    try {
      let query = "";
      if (searchTitle.length > 0) {
        query += `title=${encodeURIComponent(searchTitle)}&`;
      }
      if (searchAuthor.length > 0) {
        query += `author=${encodeURIComponent(searchAuthor)}&`;
      }
      if (selectedCategory.length > 0) {
        query += `subject=${encodeURIComponent(selectedCategory)}&`;
      }
      if (selectedLanguage.length > 0) {
        query += `lang=${encodeURIComponent(selectedLanguage)}&`;
      }
      query += `sort=${sortBy}`;

      const response = await fetch(`https://openlibrary.org/search.json?${query}`);
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const data: SearchResult = await response.json();
      setSearchResult(data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const handleSortByChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSortBy(event.target.value);
  };

  const displayBooks = () => {
    if (searchResult && searchResult.docs && searchResult.docs.length > 0) {
      return <QuickSearchResult results={searchResult} />;
    } else {
      return <p className="no-search">Aucun résultat</p>;
    }
  };

  return (
<div className="container">
  <h2 className="page-title">Recherche avancée</h2>
  <div className="search-bar">
    <div className="dropdown">
      <label htmlFor="category">Catégorie :</label>
       <br/>
      <input
        type="text"
        value={selectedCategory}
        onChange={handleCategoryChange}
        placeholder={"Catégorie"}
      />
    </div>
    <div className="dropdown">
      <label htmlFor="language">Langue :</label>
         <br/>
      <input
        type="text"
        value={selectedLanguage}
        onChange={handleLanguageChange}
        placeholder={"Langue"}
      />
    </div>
    <div className="dropdown">
      <label htmlFor="sortBy">Trier par :</label>
         <br/>
      <select id="sortBy" value={sortBy} onChange={handleSortByChange}>
        <option value="">Pertinence</option>
        <option value="new">Plus récent</option>
        <option value="old">Plus ancien</option>
        <option value="rating">Note</option>
      </select>
    </div>
    <div className="dropdown">
      <label htmlFor="search">Titre :</label>
         <br/>
      <input
        type="text"
        value={searchTitle}
        onChange={(e) => setSearchTitle(e.target.value)}
        placeholder={"Titre du livre"}
      />
    </div>
    <div className="dropdown">
      <label htmlFor="author">Auteur :</label>
         <br/> 
      <input
        type="text"
        value={searchAuthor}
        onChange={(e) => setSearchAuthor(e.target.value)}
        placeholder={"Auteur du livre"}
      />
    </div>
    <input type="button" value={"Rechercher"} onClick={handleSearch} disabled={isLoading} />
  </div>
  <div className="content">
    {isLoading ?<div> Recherche en cours... <span className="loader"></span></div>  : isSearching ? displayBooks() : <p className="no-search">Aucune recherche en cours</p>}
  </div>
  </div>
  );
}
